<template>
    <Button label="Добавить клиента" icon="pi pi-plus" class="p-button-sm" @click="showDialog" severity="info"/>

    <Dialog class="flex flex-column border-none max-w-30rem" modal
        v-model:visible="dialog"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: '900px' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Добавить клиента</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-3">
            <div class="flex flex-column w-full gap-2">
                <span class="flex">Полное имя <span class="text-red-500">*</span>: </span>
                <InputText v-model="client.first_name" class="flex" placeholder="Иван" />
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Фамилия <span class="text-red-500">*</span>: </span>
                <InputText v-model="client.last_name" class="flex" placeholder="Иванов" />
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Email <span class="text-red-500">*</span>: </span>
                <InputText v-model="client.email" class="flex" placeholder="ivan@example.com"/>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Номер телефона <span class="text-red-500">*</span>: </span>
                <InputNumber v-model="client.phone" class="flex" placeholder="79998887766" :useGrouping="false"/>
            </div>
        </div>


        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Добавить" @click='AddClient()' :loading="loading" class="flex" :disabled="loading" severity="info"/>
                <Button label="Закрыть" icon="pi pi-times" @click="dialog = false" outlined class="flex" autofocus severity="secondary" :disabled="loading"/>
            </div>
        </template>

    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    props: {
        
    },
    data() {
        return {
            loading: false,
            dialog: false,
            client: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
            },
        }
    },
    components: {

    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: 'Скопировано', detail: text, life: 1000 })
        },
        showDialog(){
            this.dialog = true
        },
        async AddClient(){
            this.loading = true
            if(!this.client.first_name || !this.client.last_name || !this.client.email || !this.client.phone){
                this.showMess('error', 'Ошибка', 'Заполните все обязательные поля')
                this.loading = false
                return
            }

            try{
                const add = await this.connect.AddPersonalClient(this.client).then(res=>res)
                if(add.result && add.data){
                    this.showMess('success', 'Успешно', 'Клиент добавлен')
                    this.dialog = false
                } else {
                    if(add.message){
                        this.showMess('error', 'Ошибка', add.message)
                    } else {
                        this.showMess('error', 'Ошибка', 'Ошибка при добавлении клиента')
                    }
                } 
            } catch(e){
                this.showMess('error', 'Ошибка', 'Ошибка при добавлении клиента')
                console.log('error', e)
            }  
            this.loading = false
        }
    },
    async mounted() {
        
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>